import { render, staticRenderFns } from "./interestsCenter.vue?vue&type=template&id=2383cdd7&scoped=true"
import script from "./interestsCenter.vue?vue&type=script&lang=js"
export * from "./interestsCenter.vue?vue&type=script&lang=js"
import style0 from "./interestsCenter.vue?vue&type=style&index=0&id=2383cdd7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2383cdd7",
  null
  
)

export default component.exports